/**
 * @param {moment.Duration} duration
 * @return {string}
 */
export function hoursMinutes(duration) {
  let past = duration < 0;
  let secs = Math.abs(duration.seconds());
  let mins = Math.abs(duration.minutes()) + (secs > 30 ? 1 : 0);
  let hours = Math.floor(Math.abs(duration.asHours()));
  let hasValue = mins !== 0 || hours !== 0;
  if (!hasValue) {
    return '';
  }
  if (mins === 60) {
    mins = 0;
    hours++;
  }
  let s = past ? '' : 'in ';
  if (hours !== 0) {
    s += `${hours} hour`;
    if (hours > 1) {
      s += 's';
    }
    s += ' ';
  }
  if (mins !== 0) {
    s += `${mins} minute`;
    if (mins > 1) {
      s += 's';
    }
  }
  s += past ? ' ago' : '';

  return s;
}
